import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const GateConfirmModalForm = ({
  device,
  setDevice,
  setOpenGateConfirmModal,
  getGateLists,
  listing,
  getListing
}) => {
const [isLoading, setLoading] = useState(false)
  const cancel = () => {
    listing?.gate_allowed && setDevice(null);
    setOpenGateConfirmModal(false);
  };

  const onGateAction = () => {
    setLoading(true)
    axios.post(`${process.env.REACT_APP_API_URL}/gates/${device.type === 'open' ? 'open' : 'close'}`, {
      gate_id: device.id
    }).then(() => {
      toast.success(`Gate ${device.type === 'open' ? 'Opened' : 'Closed'} Successfully`)
      getGateLists(listing?.listing_id)
      setOpenGateConfirmModal(false)
      setDevice(null)
    }).catch((err) => {
      toast.error(err.response.data.message)
    }).finally(() => {
      setLoading(false)
    })
  }

  const onAllowGateControl = () => {
    setLoading(true)
    axios.post(`${process.env.REACT_APP_API_URL}/gates`, {
      listing_id: listing?.listing_id,
    }).then(() => {
      toast.success(`Gate Control Allowed Successfully`)
      getListing()
      setOpenGateConfirmModal(false)
    }).catch((err) => {
      toast.error(err.response.data.message)
    }).finally(() => {
      setLoading(false)
    })
  }

  return (
    <>
      <div className="kt_body">
          <h4>
            Are you sure you want to{" "}
            <span className={`${listing?.gate_allowed ? device.type === "open" ? "text-success" : "text-danger" : "text-success"} fw-bold`}>
              {listing?.gate_allowed ? device.type === "open" ? "Open" : "Close" : "Allow Gate Control"}
            </span> {" "}
            {listing?.gate_allowed && device.device_label}
          </h4>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            type="button"
            className="btn mt-4 w-100 btn-light"
            onClick={() => cancel()}
            style={{
              color: "#000",
              height: "46px",
              fontWeight: "700"
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`btn mt-4 w-100 fw-bolder ${listing?.gate_allowed ? device.type === "open" ? "btn-success" : "btn-danger" : "btn-success"}`}
            disabled={isLoading}
            onClick={() => listing?.gate_allowed ? onGateAction() : onAllowGateControl()}
          >
            {listing?.gate_allowed ?device.type === "open" ? "Open" : "Close" : "Allow Gate Control"}
          </button>
        </div>
      </div>
    </>
  );
};

export { GateConfirmModalForm };
